module.exports = __webpack_public_path__ + "img/engraving@2x.36a5174.jpg";